export enum EQuickFilterType {
  DATE = 'DATE',
  KEYWORD = 'KEYWORD',
}

export enum EQuickFilterDateType {
  CURRENT_MONTH = 'CURRENT_MONTH',
  PREV_MONTH = 'PREV_MONTH',
  CURRENT_QUARTER = 'CURRENT_QUARTER',
  PREV_QUARTER = 'PREV_QUARTER',
  INTERVAL = 'INTERVAL',
}
